
import IllinoisSlider from '../components/Slider.vue';
import SportIcons from '../components/SportIcons.vue';
import IllinoisTabBar from '../components/TabBar.vue';
import OddsEventsGroup from '../components/OddsComponents/OddsEventsGroup.vue';
import { defineComponent } from '@vue/composition-api';
import {
  PreviewEvent,
  PreviewEventGroup,
  TournamentPreviewResponse,
  PreviewOdd,
  PreviewOutcome
} from '../../../../types/sport';
import { mapGetters } from 'vuex';
import { addOddToCartV3FromSport } from '@/composables/useOdds';
import SearchBar from '../components/Searchbar.vue';
import QuickBet from '@/components/left_widgets/QuickBet.vue';
import QuickBetItem from '../components/QuckBetItem.vue';
import TournamentIcon from '../Icons/TournamentIcon.vue';

interface EnhancedEvent {
  id: number;
  home: string;
  away: string;
  scheduled: string;
  outcomeValues: string[];
}

export default defineComponent({
  name: 'IllinoisHome',

  components: {
    IllinoisSlider,
    SportIcons,
    IllinoisTabBar,
    OddsEventsGroup,
    SearchBar,
    QuickBetItem,
    TournamentIcon
  },

  data() {
    return {
      sliderItems: [
        {
          title: 'WNBA Profit Boost',
          image:
            process.env.VUE_APP_URL_CLOUDFRONT +
            '/illinoisSlider/GenericWNBA_Profitboost_notext_eng.webp',
          sportId: '8412615417',
          categoryId: '9048397214',
          tournamentId: '7168457170'
        },
        {
          title: 'MLS Super Boost - Cincinnati vs Inter Miami',
          sportId: '8412615417',
          categoryId: '9048397214',
          tournamentId: '7168457170',
          image:
            process.env.VUE_APP_URL_CLOUDFRONT +
            '/illinoisSlider/SuperBoost_MLS_Cincinnati_v_InterMiami_notext_usa.webp'
        },
        {
          title: 'Daily Lineups',
          image:
            process.env.VUE_APP_URL_CLOUDFRONT +
            '/illinoisSlider/NewUSDailyLineups_notext_eng.webp',
          sportId: '8412615417',
          categoryId: '9048397214',
          tournamentId: '7168457170'
        },
        {
          title: 'Parlay Boost',
          image:
            process.env.VUE_APP_URL_CLOUDFRONT +
            '/illinoisSlider/NewUSParlayBoost-Generic_notext_eng.webp',
          sportId: '8412615417',
          categoryId: '9048397214',
          tournamentId: '7168457170'
        },
        {
          title: 'Club World Cup 2025',
          image:
            process.env.VUE_APP_URL_CLOUDFRONT +
            '/illinoisSlider/NewUSEPO-ClubWorldCup25_alternate_notext_eng.webp',
          sportId: '8412615417',
          categoryId: '9048397214',
          tournamentId: '7168457170'
        },
        {
          title: 'Golf Super Boost - The Open Championship',
          image:
            process.env.VUE_APP_URL_CLOUDFRONT +
            '/illinoisSlider/SuperBoost_Golf_TheOpenChampionship_notext_usa.webp',
          sportId: '8412615417',
          categoryId: '9048397214',
          tournamentId: '7168457170'
        }
      ],
      /* tournamentEvents: {} as Record<string, PreviewEventGroup[]>, */
      apiEvents: null,
      transformedEvents: [],
      activeTournament: null,
      // Scroll-spy state
      scrollScheduled: false,
      stickyOffset: 64,
      scrollContainer: null as any,
      // Larghezza viewport reattiva per aggiornare il layout su resize
      viewportWidth: (typeof window !== 'undefined'
        ? window.innerWidth
        : 1024) as number
    };
  },
  computed: {
    ...mapGetters({
      getPlatformId: 'settings/getPlatformId'
    }),
    windowWidth() {
      return this.viewportWidth;
    },
    tournamentEvents() {
      return this.$store.getters['IllinoisSport/getAllPreviewByTournament'];
    },
    illinoisSports() {
      const sports = this.$store.getters['IllinoisSport/getSports'];
      return sports;
    },
    isLoadingSports() {
      const loading = this.$store.getters['IllinoisSport/getLoading'];
      return loading;
    },
    sportsError() {
      const error = this.$store.getters['IllinoisSport/getError'];
      return error;
    },
    tournaments() {
      const tournaments =
        this.$store.getters['IllinoisSport/getFeaturedTournaments'] || [];
      return tournaments.map(tournament => {
        return {
          label: tournament.tournamentName,
          value: tournament.tournamentId,
          sportName: tournament.sportName,
          sportId: tournament.sportId,
          categoryId: tournament.categoryId
        };
      });
    },
    activeSportId(): string | undefined {
      return this.$route.params.sportId?.toString();
    },
    fullConfig() {
      return (
        (this.$store &&
          this.$store.getters &&
          this.$store.getters['uiConfig/fullUIConfig']) ||
        {}
      );
    },
    eventsForTournamentFiltered() {
      return (id: string): PreviewEventGroup[] => {
        const groups = this.eventsForTournament(id) || [];
        // Filtra gli eventi che non hanno outcomes attivi (status === 1)
        return groups
          .map(group => ({
            ...group,
            events: Array.isArray(group.events)
              ? group.events.filter((event: PreviewEvent) =>
                  this.hasActiveOutcomesForEvent(event)
                )
              : []
          }))
          .filter(
            group => Array.isArray(group.events) && group.events.length > 0
          );
      };
    },
    columnsForTournament() {
      return (tournamentId: string): string[] => {
        const groups = this.eventsForTournamentFiltered(tournamentId) || [];
        if (groups.length === 0) {
          return [];
        }

        // Raccogli tutti gli eventi da tutti i gruppi
        const allEvents: PreviewEvent[] = [];
        groups.forEach(group => {
          if (Array.isArray(group.events)) {
            allEvents.push(...group.events);
          }
        });

        if (allEvents.length === 0) {
          return [];
        }

        // Determina il tipo di struttura guardando il primo evento con odds valide
        let structureType: 'multiple-odds' | 'single-odd' | null = null;
        let firstEventWithOdds: PreviewEvent | null = null;

        for (const event of allEvents) {
          if (
            event.odds &&
            Array.isArray(event.odds) &&
            event.odds.length > 0
          ) {
            firstEventWithOdds = event;
            structureType =
              event.odds.length > 1 ? 'multiple-odds' : 'single-odd';
            break;
          }
        }

        if (!firstEventWithOdds || !structureType) {
          return [];
        }

        // Se odds.length > 1: i nomi delle colonne sono i marketName di ogni odd
        if (structureType === 'multiple-odds') {
          const columnsSet = new Set<string>();
          const columnsOrder: string[] = [];

          // Prima passata: raccogli tutte le colonne mantenendo l'ordine del primo evento
          if (firstEventWithOdds.odds) {
            firstEventWithOdds.odds.forEach(odd => {
              const marketName = odd.marketName || '';
              if (marketName && !columnsSet.has(marketName)) {
                columnsSet.add(marketName);
                columnsOrder.push(marketName);
              }
            });
          }

          // Seconda passata: aggiungi colonne da altri eventi che non sono già presenti
          allEvents.forEach(event => {
            if (event.odds && Array.isArray(event.odds)) {
              event.odds.forEach(odd => {
                const marketName = odd.marketName || '';
                if (marketName && !columnsSet.has(marketName)) {
                  columnsSet.add(marketName);
                  columnsOrder.push(marketName);
                }
              });
            }
          });

          return columnsOrder;
        }

        // Se odds.length === 1: i nomi delle colonne sono i nomi degli outcomes
        const firstOdd = firstEventWithOdds.odds[0];
        if (
          !firstOdd ||
          !firstOdd.outcome ||
          !Array.isArray(firstOdd.outcome)
        ) {
          return [];
        }

        const columnsSet = new Set<string>();
        const columnsOrder: string[] = [];

        // Prima passata: raccogli tutte le colonne mantenendo l'ordine del primo evento
        const firstOutcomes = firstOdd.outcome as PreviewOutcome[];
        firstOutcomes.forEach(outcome => {
          const columnName =
            outcome.outcome_name || outcome.outcome_alias || '';
          if (columnName && !columnsSet.has(columnName)) {
            columnsSet.add(columnName);
            columnsOrder.push(columnName);
          }
        });

        // Seconda passata: aggiungi colonne da altri eventi che non sono già presenti
        allEvents.forEach(event => {
          if (
            event.odds &&
            Array.isArray(event.odds) &&
            event.odds.length === 1 &&
            event.odds[0].outcome &&
            Array.isArray(event.odds[0].outcome)
          ) {
            const outcomes = event.odds[0].outcome as PreviewOutcome[];
            outcomes.forEach(outcome => {
              const columnName =
                outcome.outcome_name || outcome.outcome_alias || '';
              if (columnName && !columnsSet.has(columnName)) {
                columnsSet.add(columnName);
                columnsOrder.push(columnName);
              }
            });
          }
        });

        return columnsOrder;
      };
    }
  },
  async mounted() {
    window.parent.postMessage(
      {
        type: 'removeSlugs'
      },
      '*'
    );
    this.$store.dispatch('IllinoisSport/fetchTournamentsIfNeeded');
    this.fetchTournamentEvents();
    // Setup scroll-spy after initial render
    this.$nextTick(() => {
      this.recomputeStickyOffset();
      this.scrollContainer = this.findScrollContainer(this.$el as HTMLElement);
      const sc: any = this.scrollContainer || window;
      if (sc && sc.addEventListener) {
        sc.addEventListener(
          'scroll',
          this.onScroll as EventListener,
          { passive: true } as any
        );
      }
      window.addEventListener(
        'resize',
        this.onResize as EventListener,
        { passive: true } as any
      );
      this.updateActiveTournamentFromScroll();
    });
  },
  beforeDestroy() {
    const sc: any = this.scrollContainer || window;
    if (sc && sc.removeEventListener)
      sc.removeEventListener('scroll', this.onScroll as EventListener);
    window.removeEventListener('resize', this.onResize as EventListener);
  },
  watch: {
    sportsError(newError) {
      if (newError) {
        console.error('Errore nel caricamento degli sport:', newError);
      }
    },
    tournaments: {
      immediate: true,
      handler(newTournaments) {
        if (newTournaments && newTournaments.length > 0) {
          if (!this.activeTournament) {
            this.activeTournament = newTournaments[0].value;
          }
          this.fetchTournamentEvents();
          // Re-evaluate active tab after tournaments render
          this.$nextTick(() => {
            this.updateActiveTournamentFromScroll();
          });
        }
      }
    }
  },
  methods: {
    addOddToCartV3FromSport,
    onResize() {
      this.viewportWidth = window.innerWidth;
      this.recomputeStickyOffset();
      this.updateActiveTournamentFromScroll();
    },
    recomputeStickyOffset() {
      try {
        const tabRef: any = (this.$refs as any).tabBarRef;
        const tabEl: HTMLElement | undefined = tabRef
          ? tabRef.$el
            ? (tabRef.$el as HTMLElement)
            : (tabRef as HTMLElement)
          : undefined;
        if (tabEl && tabEl.getBoundingClientRect) {
          const h = tabEl.getBoundingClientRect().height;
          this.stickyOffset = Math.round(h);
        }
      } catch (_) {
        // ignore
      }
    },
    findScrollContainer(startEl: HTMLElement): HTMLElement | Window {
      let el: any = startEl;
      while (el && el !== document.body && el !== document.documentElement) {
        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll') {
          return el as HTMLElement;
        }
        el = el.parentElement;
      }
      return window;
    },
    eventsForTournament(id: string) {
      return this.$store.getters['IllinoisSport/getPreviewByTournament'](id);
    },
    hasEventsForTournament(id: string) {
      const arr = this.eventsForTournament(id);
      return Array.isArray(arr) && arr.length > 0;
    },
    hasActiveOutcomesForEvent(event: PreviewEvent): boolean {
      if (!event || !Array.isArray(event.odds)) return false;
      return event.odds.some(odd =>
        Array.isArray(odd?.outcome)
          ? odd.outcome.some(o => o.status === 1)
          : false
      );
    },

    async refreshSports() {
      await this.$store.dispatch('IllinoisSport/forceFetchSports');
    },

    async fetchTournamentEvents() {
      if (!this.tournaments || this.tournaments.length === 0) return;
      const promises = this.tournaments.map(tournament => {
        try {
          return this.$store.dispatch(
            'IllinoisSport/fetchPreviewByTournament',
            {
              sportId: String(tournament.sportId),
              categoryId: String(tournament.categoryId),
              tournamentId: String(tournament.value)
            }
          );
        } catch (error) {
          console.error(
            `Errore nel caricamento degli eventi per il torneo ${tournament.label}:`,
            error
          );
          return Promise.resolve();
        }
      });
      // Esegui in parallelo senza bloccare la UI; errori isolati non impediscono gli altri
      await Promise.allSettled(promises);
    },

    /*  getOutcomeNamesForEventGroup(eventGroup: PreviewEventGroup): string[] {
      // Prendi il primo evento del gruppo
      const firstEvent = eventGroup.events[0];

      // Cerca il mercato 1X2 o simili
      const market1X2 = firstEvent.odds.find(
        odd =>
          odd.marketName === '1X2' ||
          odd.marketName === 'Match Odds' ||
          odd.marketName === 'Match Winner'
      );

      // Se troviamo il mercato 1X2, usiamo i suoi outcome_name
      if (market1X2 && market1X2.outcome && market1X2.outcome.length > 0) {
        // Ordina gli outcome per il campo sort
        const sortedOutcomes = [...market1X2.outcome].sort(
          (a, b) => (a.sort || 0) - (b.sort || 0)
        );

        // Estrai i nomi degli outcome
        return sortedOutcomes.map(
          outcome => outcome.outcome_name || outcome.name
        );
      }

      // Se non troviamo il mercato 1X2, usiamo il primo mercato disponibile
      const firstMarket = firstEvent.odds[0];
      if (
        firstMarket &&
        firstMarket.outcome &&
        firstMarket.outcome.length > 0
      ) {
        // Ordina gli outcome per il campo sort
        const sortedOutcomes = [...firstMarket.outcome].sort(
          (a, b) => (a.sort || 0) - (b.sort || 0)
        );

        // Estrai i nomi degli outcome
        return sortedOutcomes.map(
          outcome => outcome.outcome_name || outcome.name
        );
      }

      return [];
    }, */
    /* 
    prepareEventsData(events: PreviewEvent[]): EnhancedEvent[] {
      return events.map(event => {




        // Crea un oggetto evento potenziato con i dati necessari per OddsRow
        return {
          id: event.id,
          home: event.home,
          away: event.away,
          scheduled: event.scheduled,
          oddsGroups: event.odds
        };
      });
    }, */

    handleOddSelected(selection) {
      // logica selezione
    },

    scrollToTournament(tournamentId: string) {
      const targetElement = document.getElementById(
        `tournament-${tournamentId}`
      );
      if (!targetElement) return;
      const sc: any = this.scrollContainer || window;
      const offset = this.stickyOffset || 0;
      if (sc === window) {
        const rect = targetElement.getBoundingClientRect();
        const currentScroll =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          (document.body && document.body.scrollTop) ||
          0;
        const top = currentScroll + rect.top - offset - 8;
        window.scrollTo({ top, behavior: 'smooth' });
      } else {
        const containerRect = sc.getBoundingClientRect
          ? sc.getBoundingClientRect()
          : { top: 0 };
        const rect = targetElement.getBoundingClientRect();
        const deltaTop = rect.top - (containerRect.top || 0) - offset - 8;
        if (typeof sc.scrollTo === 'function') {
          sc.scrollTo({ top: sc.scrollTop + deltaTop, behavior: 'smooth' });
        } else if (typeof sc.scrollTop === 'number') {
          sc.scrollTop = sc.scrollTop + deltaTop;
        }
      }
    },
    t(key: string) {
      return this.$t(key);
    },
    onScroll() {
      if (this.scrollScheduled) return;
      this.scrollScheduled = true;
      requestAnimationFrame(() => {
        this.updateActiveTournamentFromScroll();
        this.scrollScheduled = false;
      });
    },
    updateActiveTournamentFromScroll() {
      try {
        const sectionsRef = (this.$refs as any).tournamentSections as
          | HTMLElement[]
          | HTMLElement
          | undefined;
        if (!sectionsRef) return;
        const sections: HTMLElement[] = Array.isArray(sectionsRef)
          ? sectionsRef
          : [sectionsRef];

        if (!sections.length) return;

        const offset = this.stickyOffset || 0;
        const margin = 8; // piccolo margine per evitare flicker
        let currentId: string | null = null;
        let firstId: string | null = null;

        for (const el of sections) {
          if (!el || !el.getBoundingClientRect) continue;
          if (!firstId) firstId = el.id || '';
          const rect = el.getBoundingClientRect();
          const top = rect.top - offset;
          // Mantieni la sezione corrente finché la successiva non raggiunge la soglia
          if (top <= margin) {
            currentId = el.id || currentId;
          } else {
            // Le successive saranno più in basso, possiamo interrompere
            break;
          }
        }

        const activeId = currentId || firstId;
        if (!activeId) return;
        const idStr = activeId.replace('tournament-', '');
        const found = this.tournaments.find(
          (t: any) => String(t.value) === String(idStr)
        );
        const nextActive = found ? found.value : null;
        if (
          nextActive !== null &&
          typeof nextActive !== 'undefined' &&
          this.activeTournament !== nextActive
        ) {
          this.activeTournament = nextActive;
        }
      } catch (e) {
        // Fail silently to avoid breaking scroll
      }
    },
    zIndexForEventGroup(
      eventGroup: PreviewEventGroup,
      index: number,
      tournamentId: string
    ): string {
      const groups = this.eventsForTournament(tournamentId) || [];
      const totalGroups = Array.isArray(groups) ? groups.length : 0;
      const groupLength = Array.isArray(eventGroup?.events)
        ? eventGroup.events.length
        : 0;
      const zIndex = totalGroups + groupLength - index;
      return String(zIndex);
    }
  }
});
